import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';

import { network } from './blockchain';
import { NETWORK_IDS } from './constants';

let insufficientFunds;

switch (network.id) {
  case NETWORK_IDS.RINKEBY:
    insufficientFunds = (
      <React.Fragment>
        <Typography
          variant="subheading"
          style={{marginBottom: 10}}>
          Insufficient balance to buy item
        </Typography>
        <Typography>You can get free Ether for the Rinkeby network by:</Typography>
        <Typography component="ol">
          <li>Open MetaMask and copy your wallet address (you can do this by clicking on your account name)</li>
          <li>Create a public Google+, Twitter or Facebook post containing your wallet address</li>
          <li>Open the
            <Button
              color="primary"
              variant="contained"
              href="https://faucet.rinkeby.io/"
              target="_blank"
              style={{marginLeft: 10}}>
            <Icon className="fas fa-shower" style={{marginRight: 10}} />
            Rinkeby Faucet
            </Button>
          </li>
          <li>Paste the URL to your public post into the faucet textbox</li>
          <li>Click the <i>Give me Ether</i> button and choose an amount you want to receive e.g. <i>3 Ether</i></li>
          <li>MetaMask should refresh when the transaction is confirmed</li>
        </Typography>
      </React.Fragment>
    );
    break;
  case NETWORK_IDS.KOVAN:
    insufficientFunds = (
      <React.Fragment>
        <Typography
          variant="subheading"
          style={{marginBottom: 10}}>
          Insufficient balance to buy item
        </Typography>
        <Typography>You can get free Ether for the Kovan network by:</Typography>
        <Typography component="ol">
          <li>Open MetaMask and copy your wallet address (you can do this by clicking on your account name)</li>
          <li>Open the
            <Button
              color="primary"
              variant="contained"
              href="https://github.com/kovan-testnet/faucet"
              target="_blank"
              style={{marginLeft: 10}}>
            <Icon className="fas fa-shower" style={{marginRight: 10}} />
            Kovan Faucet
            </Button>
          </li>
          <li>Use either the GitHub OAuth or Gitter channel</li>
          <li>MetaMask should refresh when the transaction is confirmed</li>
        </Typography>
      </React.Fragment>
    );
    break;
  case NETWORK_IDS.MAIN:
    insufficientFunds = (
      <React.Fragment>
        <Typography
          variant="subheading"
          style={{marginBottom: 10}}>
          Insufficient balance to buy item
        </Typography>
        <Typography>You can get Ether by:</Typography>
        <Typography component="ol">
          <li>Open MetaMask</li>
          <li>Click the Deposit button</li>
          <li>Follow the instruction to buy buy Ether from Coinbase or another exchange</li>
        </Typography>
      </React.Fragment>
    );
    break;
  default:
    insufficientFunds = (
      <Typography variant="subheading">Insufficient balance to buy item</Typography>
    );
}

export const INSUFFICIENT_FUNDS = insufficientFunds;



// WEBPACK FOOTER //
// ./src/config/strings.js